import { array, boolean, mixed, number, object, string } from 'yup';

import { ConversationSelectType } from '../../../../../data/data/conversations/enums';
import { ReminderMessageType } from '../../../../../data/data/reminders/enums';
import {
  ConsultType,
  Honorific,
  ReminderFrequency,
} from '../../../../../data/types/api/graphql';
import { messages, trim } from '../../../../../data/utils/form.utils';

export const schema = object()
  .shape({
    patientId: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    conversationType: mixed<ConversationSelectType>()
      .oneOf(Object.values(ConversationSelectType))
      .required(messages.required.id)
      .default(ConversationSelectType.EXISTING),
    conversationId: string()
      .transform(trim)
      .when('conversationType', {
        is: (conversationType: ConversationSelectType) =>
          conversationType === ConversationSelectType.EXISTING,
        then: currentSchema => currentSchema.required(messages.required.id),
      })
      .default(''),
    conversationTitle: string()
      .transform(trim)
      .when('conversationType', {
        is: (conversationType: ConversationSelectType) =>
          conversationType === ConversationSelectType.NEW,
        then: currentSchema => currentSchema.required(messages.required.id),
      })
      .default(''),
    startDate: string()
      .transform(trim)
      .required(messages.required.id)
      .default(''),
    frequency: mixed<ReminderFrequency>()
      .oneOf(Object.values(ReminderFrequency))
      .required(messages.required.id)
      .default(ReminderFrequency.Once),
    endDate: boolean()
      .transform(option => option ?? false)
      .default(false),
    occurrence: number()
      .when('frequency', {
        is: (frequency: ReminderFrequency) =>
          frequency !== ReminderFrequency.Once,
        then: currentSchema => currentSchema.min(1, messages.required.id),
      })
      .default(1),
    messageType: mixed<ReminderMessageType>()
      .oneOf(Object.values(ReminderMessageType))
      .required(messages.required.id)
      .default(ReminderMessageType.Custom),
    message: string()
      .transform(trim)
      .when('messageType', {
        is: (messageType: ReminderMessageType) =>
          messageType === ReminderMessageType.Custom,
        then: currentSchema => currentSchema.required(messages.required.id),
      })
      .default(''),
    appointmentConsultTypes: array(
      mixed<ConsultType>().oneOf(Object.values(ConsultType))
    )
      .when('messageType', {
        is: (messageType: ReminderMessageType) =>
          messageType === ReminderMessageType.Appointment,
        then: currentSchema => currentSchema.required(messages.required.id),
      })
      .default([ConsultType.Physical]),

    appointmentHonorifics: array(
      object().shape({
        key: mixed<Honorific>()
          .transform(value => {
            if (value === null || value === undefined) {
              return undefined;
            }
            return value;
          })
          .oneOf(Object.values(Honorific))
          .required(messages.required.id),
        value: number().required(messages.required.id),
      })
    ).when('messageType', {
      is: (messageType: ReminderMessageType) =>
        messageType === ReminderMessageType.Appointment,
      then: currentSchema => currentSchema.required(messages.required.id),
    }),
    appointmentHealthProfessionalId: string().transform(trim).default(''),
  })
  .required()
  .noUnknown();
